import IndividualAbsenceTypeFields from './individual-absence-type-fields'

export default IndividualAbsenceTypeFields
